import apiConfig from "../../apiConfig";

export const validateDonationSideData = async (
	at,
	{
		Active_Status_Id,
		Donation_Side_Name_AR = "",
        Donation_Side_Name_EN = "",
		Donation_Side_Id
	}
) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Sides/Validate_Donation_Side",
		{
			Active_Status_Id,
			Donation_Side_Name_AR,
			Donation_Side_Name_EN,
			Donation_Side_Id
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
